import React from 'react';
// import { hashHistory } from "react-router";
// import { Router } from "react-router";
import { createBrowserHistory } from "history";
import {
    HashRouter as Router,
    Route, Switch,
    // BrowserRouter as Router,
} from 'react-router-dom';
import App from "../App";
import NoteShare from "../components/NoteShare";
import Download from "../components/Download";
import RikeDownload from "../components/RikeDownload";
import RikeNoteShare from "../components/RikeNoteShare"; // 日刻单篇日记分享
import RikeFirst from "../components/RikeFirst"; // 日刻首发活动
import RikeFirst2 from "../components/RikeFirst2";
import RikeAgent from "../components/RikeAgent"; // 日刻服务商邀请别人注册
import RikeAgentPay from "../components/RikeAgentPay"; // 日刻代理商二维码扫描支付

const history = createBrowserHistory();

export default class MainRouter extends React.Component {
    render() {
        return (
            <Router history={history}>
                <div>
                    <Route exact path="/" component={App} />
                    <Route exact path="/diaryDetail/:id" component={NoteShare} />
                    <Route exact path="/download" component={Download} />
                    <Route exact path="/rike/download" component={RikeDownload} />
                    <Route exact path="/rike/diaryDetail/:id" component={RikeNoteShare} />
                    <Route exact path="/rike/first" component={RikeFirst} />
                    <Route exact path="/rike/first2" component={RikeFirst2} />
                    <Route exact path="/rike/agent" component={RikeAgent} />
                    <Route exact path="/rike/agent-pay" component={RikeAgentPay} />
                </div>
            </Router>
        );
    }
}